import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { ProcessoSetores, ProcessoSetoresList, ProcessoConcluirDTO } from "../../../types/processo/ProcessoSetoresDTO";



const endpointUrl = configUrls.PROCESSO_EP

function concluirProcesso(obj: ProcessoConcluirDTO) {
    return {
        url: `${endpointUrl}/concluir/create`,
        method: "POST",
        body: obj,
    }

}

function cancelarConcluido({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/concluir/${id}`,
        method: "DELETE",
    }
}

function getConcluidos({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        url: `${endpointUrl}/concluidos/${id}?search=${search}`,
        method: "GET",
    }
}

function getConcluido(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/concluir/${id}`,
        method: "GET",
    }
}

function deleteConcluido({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/concluir/${id}`,
        method: "DELETE",
    }
}

export const processoConcluirApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({


        getConcluidos: query<ProcessoSetoresList[], { id: string, search: string }>({

            query: getConcluidos,
            providesTags: ["ProcessoConcluir"],
        }),

        getConcluido: query<ProcessoSetores, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getConcluido,
            providesTags: ["ProcessoConcluir"],
        }),

        concluirProcesso: mutation<void, ProcessoConcluirDTO>(
            {
                query: concluirProcesso,
                invalidatesTags: ["ProcessoConcluir"]
            }),
        deleteConcluido: mutation<void, { id: string }>(
            {
                query: deleteConcluido,
                invalidatesTags: ["ProcessoConcluir"],
            }),


    }),

});
export const {
    useGetConcluidosQuery,
    useGetConcluidoQuery,
    useConcluirProcessoMutation,
    useDeleteConcluidoMutation,
} = processoConcluirApiSlice;
